import type { Key, ReactNode } from 'react';
import { Tooltip, type TooltipChildNode, type TooltipProps } from '../Tooltip';

export const maybeWrapWithTooltip =
  (props: TooltipProps | null, key?: Key) =>
  (node: TooltipChildNode): ReactNode =>
    props === null ? (
      node
    ) : (
      <Tooltip key={key} {...props}>
        {node}
      </Tooltip>
    );
